import { createFileRoute, redirect } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { getExpiresAt } from "@/features/auth/lib/token";
import { refreshNexusToken } from "@/features/auth/lib/refresh";
import { useAuth } from "@/features/auth/hooks/useAuth";
import { getDefaultRoute } from "@/features/auth/lib/page-routes";
import { LoginForm } from "@/features/auth/components/LoginForm";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export const Route = createFileRoute("/login")({
  beforeLoad: async () => {
    const expiresAt = getExpiresAt();
    const nowSeconds = Math.floor(Date.now() / 1000);

    if (expiresAt && expiresAt > nowSeconds) {
      const { tenants, lastVisitedRoute } = useAuth.getState();
      const dest = getDefaultRoute(tenants, lastVisitedRoute);
      if (dest) throw redirect({ to: dest });
    }

    // Session expired or missing — try refresh before showing login
    if (expiresAt) {
      try {
        await refreshNexusToken();
        const { tenants, lastVisitedRoute } = useAuth.getState();
        const dest = getDefaultRoute(tenants, lastVisitedRoute);
        if (dest) throw redirect({ to: dest });
      } catch (err) {
        if (err instanceof Response || (err && typeof err === "object" && "to" in err)) throw err;
        // Refresh failed — fall through to show login form
      }
    }
  },
  component: LoginPage,
});

function LoginPage() {
  const { t } = useTranslation();
  useDocumentTitle(t("page.title.login"));
  return <LoginForm />;
}
